/**
 * Action types for AAA server functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_AAA_SERVER = 'GET_AAA_SERVER';
export const GET_AAA_SERVER_SUCCESS = 'GET_AAA_SERVER_SUCCESS';
export const GET_AAA_SERVER_FAIL = 'GET_AAA_SERVER_FAIL';
export const DELETE_AAA_SERVER = 'DELETE_AAA_SERVER';
export const DELETE_AAA_SERVER_SUCCESS = 'DELETE_AAA_SERVER_SUCCESS';
export const DELETE_AAA_SERVER_FAIL = 'DELETE_AAA_SERVER_FAIL';
export const ADD_AAA_SERVER = 'ADD_AAA_SERVER';
export const ADD_AAA_SERVER_COMPLETE =  'ADD_AAA_SERVER_COMPLETE';
export const EDIT_AAA_SERVER = 'EDIT_AAA_SERVER'
export const EDIT_AAA_SERVER_COMPLETE =  'EDIT_AAA_SERVER_COMPLETE'
export const AAA_SERVER_ADD_TRIGGER = 'AAA_SERVER_ADD_TRIGGER';